import { css } from 'styled-components';

export default css`
  .buttons-container {
    display: flex;
    justify-content: right;
  }
`;
